import React, { CSSProperties, ReactElement } from "react";

import HystarDrylabImage from "@Images/HystarDrylabImage";
import HystarWetlabImage from "@Images/HystarWetlabImage";
import HystarEmigImage from "@Images/HystarEmigImage";
import LaparGeneralImage from "@Images/LaparGeneralImage";
import LaparGynaeImage from "@Images/LaparGynaeImage";
import LaparLappassImage from "@Images/LaparLappassImage";
import DefaultActivityImage from "@Images/DefaultActivityImage";
import {PublicAssetsUrl} from "@Constants";

const hystarDryLab = PublicAssetsUrl + "/web/hystar-drylab.svg";
const hystarWetLab  = PublicAssetsUrl + "/web/hystar-wetlab.svg";
const hystarEmig  = PublicAssetsUrl + "/web/hystar-emig.svg";
const laparGeneral  = PublicAssetsUrl + "/web/lapar-general.svg";
const laparGynae  = PublicAssetsUrl + "/web/lapar-gynae.svg";
const laparLapPass  = PublicAssetsUrl + "/web/lapar-lappass.svg";
const defaultActivityImage  = PublicAssetsUrl + "/web/default-activity.svg";

type IActivityIcon = (
    categoryName: string, 
    color?: string, 
    svgWidth?: string, 
    svgHeight?: string, 
    style?: CSSProperties) => ReactElement;

export const getActivityIcon: IActivityIcon = (
        categoryName,
        color,
        svgWidth,
        svgHeight,
        style
    ) => {

    const svgProps = { color, svgWidth, svgHeight, style };
    const svg: Map<string, JSX.Element> = new Map<string, JSX.Element>([
        ["hystar-dry-lab", <HystarDrylabImage {...svgProps} />],
        ["hystar-wet-lab", <HystarWetlabImage {...svgProps} />],
        ["hystar-emig", <HystarEmigImage {...svgProps} />],
        ["lapar-general-surgery", <LaparGeneralImage {...svgProps} />],
        ["lapar-gynaecology", <LaparGynaeImage {...svgProps} />],
        ["lapar-lap-pass", <LaparLappassImage {...svgProps} />]
    ]);
    return svg.has(categoryName) ? svg.get(categoryName) : <DefaultActivityImage {...svgProps} />;
};

export const getActivityIconBackground = (categoryName: string) => {
    const svg: Map<string, string> = new Map<string, string>([
        ["hystar-dry-lab", hystarDryLab],
        ["hystar-wet-lab", hystarWetLab],
        ["hystar-emig", hystarEmig],
        ["lapar-general-surgery", laparGeneral],
        ["lapar-gynaecology", laparGynae],
        ["lapar-lap-pass", laparLapPass]
    ]);

    return svg.has(categoryName) ? svg.get(categoryName) : defaultActivityImage;
};